<template>
    <div class="resetpwd_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('forgetpwe.reset')}}</div>
        </div>
        <form class="form" @submit.prevent="submit">
            <!-- 邮箱/手机切换 -->
            <div class="reg-type-switch">
                <div :class="['reg-type-item', inputType === 'email' ? 'active' : '']" @click="switchType('email')">
                    {{$t('register.regTypeEmail')}}
                </div>
                <div :class="['reg-type-item', inputType === 'phone' ? 'active' : '']" @click="switchType('phone')">
                    {{$t('register.regTypePhone')}}
                </div>
            </div>

            <!-- 邮箱输入 -->
            <div v-if="inputType === 'email'" class="item">
                <input type="text" class="inp" v-model.trim="data.mobile" :placeholder="$t('forgetpwe.phoneNumber')"/>
            </div>

            <!-- 手机号输入 -->
            <div v-if="inputType === 'phone'" class="item phone-item">
                <div class="country-code-btn" @click="showCountryPicker = true">
                    <span class="country-flag">{{ selectedCountry.flag }}</span>
                    <span class="country-dial">{{ selectedCountry.code }}</span>
                    <span class="arrow-down">▾</span>
                </div>
                <div class="divider-line"></div>
                <input v-model.trim="phoneNum" type="tel" class="inp" :placeholder="$t('register.phoneInput')">
            </div>

            <div class="item">
                <input type="text" class="inp" v-model.trim="data.code" :placeholder="$t('forgetpwe.code')"/>
                <van-count-down :time="time" class="btn get_captcha" @finish="timeCall">
                    <template v-slot="timeData">
                        <span @click="sendcode">{{timeData.seconds > 0 ? timeData.seconds : $t('forgetpwe.send')}}</span>
                    </template>
                </van-count-down>
            </div>
            <div class="item">
                <input type="password" class="inp" v-model.trim="data.password" :placeholder="$t('forgetpwe.newPassword')"/>
            </div>
        </form>
        <button type="submit" class="btn basic_btn" @click="submit">{{$t('forgetpwe.submit')}}</button>

        <!-- 区号选择器弹窗 -->
        <van-popup v-model="showCountryPicker" position="bottom" class="country-popup">
            <div class="country-picker-header">
                <span>{{ $t('register.selectCountry') }}</span>
                <span class="cp-close" @click="showCountryPicker = false">✕</span>
            </div>
            <div class="country-search">
                <input v-model="searchQuery" type="text" class="country-search-input" :placeholder="$t('register.searchCountry')">
            </div>
            <div class="country-list">
                <div
                    v-for="(item, index) in filteredCountries"
                    :key="index"
                    class="country-item"
                    :class="{ 'country-item--active': selectedCountry.code === item.code }"
                    @click="selectedCountry = item; showCountryPicker = false; searchQuery = ''"
                >
                    <span class="ci-flag">{{ item.flag }}</span>
                    <span class="ci-name">{{ item.name }}</span>
                    <span class="ci-code">{{ item.code }}</span>
                    <span v-if="selectedCountry.code === item.code" class="ci-check">✓</span>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {CountDown, Checkbox, Popup} from 'vant';
    import Fetch from '../../utils/fetch'

    Vue.use(CountDown).use(Checkbox).use(Popup);

    const COUNTRIES = [
        { flag: '🇨🇳', name: '中国', code: '+86' },
        { flag: '🇭🇰', name: '香港', code: '+852' },
        { flag: '🇹🇼', name: '台灣', code: '+886' },
        { flag: '🇺🇸', name: 'United States', code: '+1' },
        { flag: '🇬🇧', name: 'United Kingdom', code: '+44' },
        { flag: '🇦🇺', name: 'Australia', code: '+61' },
        { flag: '🇸🇬', name: 'Singapore', code: '+65' },
        { flag: '🇯🇵', name: '日本', code: '+81' },
        { flag: '🇰🇷', name: '한국', code: '+82' },
        { flag: '🇹🇭', name: 'ประเทศไทย', code: '+66' },
        { flag: '🇲🇾', name: 'Malaysia', code: '+60' },
        { flag: '🇻🇳', name: 'Việt Nam', code: '+84' },
        { flag: '🇧🇷', name: 'Brasil', code: '+55' },
        { flag: '🇵🇭', name: 'Pilipinas', code: '+63' },
        { flag: '🇮🇩', name: 'Indonesia', code: '+62' },
        { flag: '🇮🇳', name: 'भारत', code: '+91' },
        { flag: '🇫🇷', name: 'France', code: '+33' },
        { flag: '🇮🇹', name: 'Italia', code: '+39' },
        { flag: '🇸🇦', name: 'السعودية', code: '+966' },
        { flag: '🇦🇪', name: 'الإمارات', code: '+971' },
        { flag: '🇪🇬', name: 'مصر', code: '+20' },
        { flag: '🇰🇼', name: 'الكويت', code: '+965' },
        { flag: '🇶🇦', name: 'قطر', code: '+974' },
    ];

    export default {
        name: "forgetpwd",
        data() {
            return {
                time: 0,
                inputType: 'email',
                phoneNum: '',
                showCountryPicker: false,
                searchQuery: '',
                selectedCountry: COUNTRIES[0],
                data: {
                    mobile: '',
                    code: '',
                    password: '',
                }
            };
        },
        computed: {
            filteredCountries() {
                if (!this.searchQuery) return COUNTRIES;
                const q = this.searchQuery.toLowerCase();
                return COUNTRIES.filter(c =>
                    c.name.toLowerCase().includes(q) || c.code.includes(q)
                );
            }
        },
        created() {
            this.$parent.footer('user', false);
        },
        methods: {
            switchType(type) {
                this.inputType = type;
                this.data.mobile = '';
                this.phoneNum = '';
            },
            getMobile() {
                if (this.inputType === 'phone') {
                    return this.selectedCountry.code + this.phoneNum;
                }
                return this.data.mobile;
            },
            timeCall() {
                this.is_send = false;
                this.time = 0;
            },
            sendcode() {
                if (this.is_send) return;

                const mobile = this.getMobile();
                if (!mobile) {
                    this.$toast(this.$t('forgetpwe.phoneNumberEmpty'));
                    return;
                }

                this.is_send = true;

                Fetch("/index/forgetpwd_code", {
                    mobile: mobile,
                    lang: this.$i18n.locale || "en_us"
                }).then(() => {
                    this.time = 60 * 1000;
                    this.$toast({
                        className: "toastName",
                        message: this.$t('forgetpwe.sendSuccess'),
                    });
                }).catch(() => {
                    this.is_send = false;
                });
            },
            submit() {
                const mobile = this.getMobile();

                if (!mobile) {
                    this.$toast(this.$t('forgetpwe.phoneNumberEmpty'));
                    return;
                }

                if (!this.data.password) {
                    this.$toast(this.$t('forgetpwe.newPasswordEmpty'));
                    return;
                }

                if (!this.data.code) {
                    this.$toast(this.$t('forgetpwe.codeEmpty'));
                    return;
                }

                Fetch("/index/forgetpwd_nologin", {
                    mobile: mobile,
                    password: this.data.password,
                    code: this.data.code
                }).then(() => {
                    this.$toast({
                        className: "toastName",
                        message: this.$t('forgetpwe.success'),
                    });
                }).then(() => {
                    this.$router.replace('/login');
                });
            },
        }
    };
</script>

<style lang="less" scoped>
    .back_left {
        background: url(../../views/images/item/back_b.png) no-repeat center center;
    }
    .big_tit {
        color: #ffffff;
    }
    .resetpwd_wrap .form {
        display: block;
        background-color: #ffffff;
        padding: 0 15px;
    }
    .reg-type-switch {
        display: flex;
        align-items: center;
        margin: 16px 0 12px 0;
        background-color: #ebebeb;
        border-radius: 10px;
        padding: 4px;
        .reg-type-item {
            flex: 1;
            text-align: center;
            font-size: 14px;
            font-weight: 500;
            color: #333;
            padding: 10px 0;
            border-radius: 8px;
            cursor: pointer;
            transition: background 0.2s, color 0.2s;
            &.active {
                color: #fff;
                font-weight: 700;
                background-image: linear-gradient(to right, #f12211, #f18a11);
                box-shadow: 0 2px 8px rgba(241, 34, 17, 0.35);
            }
        }
    }
    .resetpwd_wrap .form .item {
        display: flex;
        width: 100%;
        align-items: center;
        border-bottom: 1px solid #eeeeee;
        padding: 10px 0;
    }
    .resetpwd_wrap .form .item .inp {
        flex: 1 1 auto;
        border-radius: 5px;
        font-size: 14px;
        height: 30px;
        padding: 0 10px;
        background: #fff;
    }
    .phone-item {
        padding: 0 !important;
        border-bottom: 1px solid #eeeeee;
        height: 50px;
        .country-code-btn {
            display: flex;
            align-items: center;
            padding: 0 8px 0 0;
            cursor: pointer;
            white-space: nowrap;
            height: 100%;
            .country-flag { font-size: 18px; margin-right: 4px; }
            .country-dial { font-size: 14px; color: #333; min-width: 38px; }
            .arrow-down { font-size: 12px; color: #999; margin-left: 2px; }
        }
        .divider-line {
            width: 1px;
            height: 20px;
            background-color: #dfdfdf;
            margin: 0 8px;
            flex-shrink: 0;
        }
        input {
            flex: 1;
            height: 30px;
            font-size: 14px;
            background: #fff;
            padding: 0 10px;
        }
    }
    .get_captcha {
        padding: 0 10px;
        margin-left: 10px;
        font-size: 14px;
        text-align: center;
        line-height: 32px;
        color: #FFFFFF;
        height: 32px;
        background: linear-gradient(to right, #ed540b, #e82637);
        border-radius: 8px;
        white-space: nowrap;
    }
    .resetpwd_wrap .basic_btn {
        width: 220px;
        display: block;
        margin: 20px auto 0 auto;
    }
</style>
<style>
    .country-popup {
        border-radius: 12px 12px 0 0;
        overflow: hidden;
    }
    .country-picker-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 16px 12px;
        font-size: 15px;
        font-weight: 500;
        color: #333;
        border-bottom: 1px solid #f2f2f2;
    }
    .cp-close {
        font-size: 18px;
        color: #bbb;
        cursor: pointer;
        padding: 0 4px;
    }
    .country-search {
        padding: 8px 12px;
        border-bottom: 1px solid #f2f2f2;
    }
    .country-search-input {
        width: 100%;
        height: 34px;
        background: #f5f5f5;
        border: none;
        border-radius: 6px;
        padding: 0 12px;
        font-size: 14px;
        color: #333;
        box-sizing: border-box;
        outline: none;
    }
    .country-list {
        max-height: 55vh;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }
    .country-item {
        display: flex;
        align-items: center;
        padding: 12px 16px;
        border-bottom: 1px solid #f5f5f5;
        cursor: pointer;
    }
    .country-item--active { background-color: #fff8f7; }
    .ci-flag { font-size: 20px; width: 30px; flex-shrink: 0; }
    .ci-name { flex: 1; font-size: 14px; color: #333; }
    .ci-code { font-size: 14px; color: #888; margin-right: 6px; }
    .ci-check { color: #f12211; font-size: 15px; font-weight: bold; }
</style>
